/* eslint-disable react-hooks/rules-of-hooks */

import {useGetAudiences} from '../../../../../../core/select/hooks/use-get-audiences';

import {mapAudienceToSelectItem} from '../../map-audience-to-select-item';
import type {AudienceOption} from '../../map-audience-to-select-item';

import {useGetMcfxAudiencesFromApi} from './use-get-mcfx-audiences-from-api';

export const getAudiencesForSending = () => {
    const {audiences, refetch, isLoading} = useGetAudiences();
    const {
        mcfxAudiencesViaApi,
        refetch: refetchMcfxAudiences,
        isLoading: isLoadingMcfxAudiences,
    } = useGetMcfxAudiencesFromApi(!NutClientConfig.instanceOriginatedFromWebFX);

    const audienceOptions: AudienceOption[] = audiences.map(mapAudienceToSelectItem);

    if (mcfxAudiencesViaApi && mcfxAudiencesViaApi.length) {
        mcfxAudiencesViaApi.forEach((mcfxApiAudience) => {
            audienceOptions.push({
                value: mcfxApiAudience.externalId,
                label: mcfxApiAudience.name,
                count: mcfxApiAudience.size,
                requiresSync: true,
                isFx: true,
                isSyncing: false,
            });
        });
    }

    return {
        isLoading: isLoading || isLoadingMcfxAudiences,
        refetch,
        refetchMcfxAudiences,
        options: audienceOptions,
    };
};
